import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { disableReactDevTools } from '@fvilers/disable-react-devtools'
import { Provider } from 'react-redux'
import { PublicClientApplication, EventType } from '@azure/msal-browser'
import { MsalProvider } from '@azure/msal-react'
import { ToastContainer } from 'react-toastify'

import 'react-toastify/dist/ReactToastify.css'
import 'react-datepicker/dist/react-datepicker.css'

import './index.css'
import App from './App'
import { store } from './store'
import ScrollToTop from './components/ScrollToTop'
import { msalConfig } from './config/msalConfig'

if (process.env.NODE_ENV === 'production') {
	disableReactDevTools()
}

const msalInstance = new PublicClientApplication(msalConfig)

msalInstance.addEventCallback(event => {
	if (event.eventType === EventType.LOGIN_SUCCESS) {
		window.location.href = '/login'
		msalInstance.setActiveAccount(event.payload.account)
	}
})

const root = ReactDOM.createRoot(document.getElementById('root'))

root.render(
	<MsalProvider instance={msalInstance}>
		<Provider store={store}>
			<BrowserRouter>
				<ScrollToTop />
				<App />
			</BrowserRouter>
			<ToastContainer />
		</Provider>
	</MsalProvider>
)
